import React from "react";
import ContentLoader from "react-content-loader";

const Skeleton = () => (
  <ContentLoader speed={3}>
    <rect x="10" y="10" rx="5" ry="5" width="375" height="180" />
    <rect x="6" y="190" rx="0" ry="0" width="292" height="20" />
    <rect x="4" y="215" rx="0" ry="0" width="239" height="20" />
    <rect x="4" y="242" rx="0" ry="0" width="274" height="20" />
  </ContentLoader>
);

export default Skeleton;
